import { initDB, getSetting, setSetting } from '../db/indexeddb.js';

const CLIENT_ID_KEY = 'ytcs:oauth-client-id';
const API_KEY = 'ytcs:api-key';
const CHANNEL_ID = 'ytcs:channel-id';

export async function getClientId() {
  const db = await initDB();
  const stored = await getSetting(db, CLIENT_ID_KEY);
  return stored?.value || null;
}

export async function setClientId(value) {
  if (!value) return;
  const db = await initDB();
  await setSetting(db, CLIENT_ID_KEY, value.trim());
}

export async function getApiKey() {
  const db = await initDB();
  const stored = await getSetting(db, API_KEY);
  return stored?.value || null;
}

export async function setApiKey(value) {
  if (!value) return;
  const db = await initDB();
  await setSetting(db, API_KEY, value.trim());
}

export async function getDefaultChannelId() {
  const db = await initDB();
  const stored = await getSetting(db, CHANNEL_ID);
  return stored?.value || null;
}

export async function setDefaultChannelId(value) {
  if (!value) return;
  const db = await initDB();
  await setSetting(db, CHANNEL_ID, value.trim());
}

export function getRedirectUri() {
  // Use a dedicated callback path so we can reliably detect OAuth responses.
  // Ensure your hosting serves index.html for this path (SPA fallback).
  return `${window.location.origin}/oauth/callback`;
}

export function getScopes() {
  return 'https://www.googleapis.com/auth/youtube.readonly';
}
